import { TFunction } from "i18next";
import { ROUTES } from "../../../constant/common.constant";

import { generatePath } from "react-router-dom";

export const getBackRoutes = (
  t: TFunction,
  historyFrom?: string,
  orderType?: string,
  orderId?: string
) => {
  let route = "";
  let label = "";

  if (historyFrom === "techpack") {
    label = t("studio_toolbar.back_to_techpack");
    if (orderType === "preorder") {
      route = generatePath(ROUTES.ADMIN_TECHPACK_ORDER, {
        orderId: orderId,
      });
    }
  } else if (historyFrom === "adminpurchased") {
    if (orderType === "preorder") {
      route = generatePath(ROUTES.ADMIN_ORDER, {
        orderId: orderId,
      });
      label = t("studio_toolbar.back_to_preorder");
    } else {
      label = "Return to ???";
    }
  }

  return {
    backPageRoute: route,
    backPageLabel: label,
    backPageTooltip: label,
  };
};
